import React, { useState } from 'react';
import { Checkbox, FilledInput } from '@material-ui/core';
import { Translate } from '@hydra/common/components';

interface SubFolderSelectionProps {
  subFolderPlaceholder: string
  disabled: boolean
  error: any
  handleSubFolderChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
  handleKeyDown: (e: any) => void
  classes: { [key: string]: string }
  id: string
  subFolderValue?: string
}

export default function SubFolderSelection ({
  subFolderPlaceholder,
  disabled,
  error,
  handleSubFolderChange,
  handleKeyDown,
  classes,
  id,
  subFolderValue
}: SubFolderSelectionProps) {
  const [subFolderChecked, setSubfolderChecked] = useState(false);

  return (
    <>
      {
        subFolderChecked
          ? (
            <FilledInput
              disabled={disabled}
              error={error}
              inputProps={{
                className: 'nr-generation-form-input',
                autoComplete: 'off'
              }}
              fullWidth
              placeholder={subFolderPlaceholder}
              disableUnderline
              onChange={handleSubFolderChange}
              onKeyDown={handleKeyDown}
              classes={{
                root: classes.root,
                input: classes.input
              }}
              value={subFolderValue}
              startAdornment='/'
              {...id && { id: `${id}-subfolder` }}
            />
            )
          : null
      }
      <Checkbox
        checked={subFolderChecked}
        onChange={() => setSubfolderChecked(!subFolderChecked)}
        name='enable-subfolder'
      />
      <Translate content='generation_subfolder_text' />
    </>
  );
}
